/** Type-safe I18n key constants */
export const I18N_KEYS = {
  APP_TITLE: 'app.title',
  HEADER_SETTINGS: 'header.settings',

  CONTROLS_NEXT_NUMBER: 'controls.nextNumber',
  CONTROLS_START_GAME: 'controls.startGame',
  CONTROLS_AUTO_PLAY: 'controls.autoPlay',
  CONTROLS_RESET: 'controls.reset',
  CONTROLS_NEXT_IN: 'controls.nextIn',
  CONTROLS_PREVIOUS: 'controls.previous',

  DISPLAY_READY: 'display.ready',
  DISPLAY_PLAYING: 'display.playing',
  DISPLAY_SKIP_AUDIO: 'display.skipAudio',

  SETTINGS_TITLE: 'settings.title',
  SETTINGS_LANGUAGE: 'settings.language',
  SETTINGS_STYLE: 'settings.style',
  SETTINGS_RANGE: 'settings.range',
  SETTINGS_MIN: 'settings.min',
  SETTINGS_MAX: 'settings.max',
  SETTINGS_INTERVAL: 'settings.interval',
  SETTINGS_APPLY: 'settings.apply',
  SETTINGS_CANCEL: 'settings.cancel',
  SETTINGS_UI_LANGUAGE: 'settings.uiLanguage',
  SETTINGS_PREVIEW: 'settings.preview',
  SETTINGS_RANGE_LOCKED: 'settings.rangeLocked',
  SETTINGS_HOT_SWITCH_WARNING: 'settings.hotSwitchWarning',

  RESET_TITLE: 'reset.title',
  RESET_MESSAGE: 'reset.message',
  RESET_CONFIRM: 'reset.confirm',
  COMPLETE_TITLE: 'complete.title',
  COMPLETE_NUMBERS_CALLED: 'complete.numbersCalled',
  COMPLETE_TIME_ELAPSED: 'complete.timeElapsed',
  COMPLETE_STYLE: 'complete.style',
  COMPLETE_VIEW_HISTORY: 'complete.viewHistory',
  COMPLETE_NEW_GAME: 'complete.newGame',
  HISTORY_TITLE: 'history.title',
  HISTORY_EXPORT_CSV: 'history.exportCsv',
  HISTORY_CLOSE: 'history.close',
  HISTORY_ORDER: 'history.order',
  HISTORY_NUMBER: 'history.number',

  STATUS_CALLED: 'status.called',
  STATUS_TIME: 'status.time',

  TOAST_SETTINGS_SAVED: 'toast.settingsSaved',
  TOAST_STYLE_CHANGED: 'toast.styleChanged',
  TOAST_AUDIO_UNAVAILABLE: 'toast.audioUnavailable',
  TOAST_AUTO_PLAY_PAUSED: 'toast.autoPlayPaused',
  TOAST_AUTO_PLAY_RESUMED: 'toast.autoPlayResumed',
  TOAST_AUDIO_BLOCKED: 'toast.audioBlocked',
  TOAST_CONNECTION_LOST: 'toast.connectionLost',
  TOAST_CONNECTION_RESTORED: 'toast.connectionRestored',
  TOAST_STORAGE_LIMIT: 'toast.storageLimitReached',
  TOAST_CORRUPTED_DATA: 'toast.corruptedData',
  TOAST_PLEASE_WAIT: 'toast.pleaseWait',
  TOAST_PREVIEW_NOT_AVAILABLE: 'toast.previewNotAvailable',
  TOAST_PREVIEW_FAILED: 'toast.previewFailed',
  TOAST_PREVIEW_PLAYING: 'toast.previewPlaying',

  EMERGENCY_TITLE: 'emergency.title',
  EMERGENCY_MESSAGE: 'emergency.message',
  EMERGENCY_RETRY: 'emergency.retry',

  A11Y_NUMBER_CALLED: 'a11y.numberCalled',
  A11Y_GAME_COMPLETE: 'a11y.gameComplete',
  A11Y_SKIP_TO_CONTENT: 'a11y.skipToContent',
  A11Y_GRID_LABEL: 'a11y.gridLabel',
  A11Y_CELL_CALLED: 'a11y.cellCalled',
  A11Y_CELL_NOT_CALLED: 'a11y.cellNotCalled',

  KEYBOARD_TITLE: 'keyboard.title',
  KEYBOARD_NEXT: 'keyboard.next',
  KEYBOARD_AUTOPLAY: 'keyboard.autoplay',
  KEYBOARD_SETTINGS: 'keyboard.settings',
  KEYBOARD_RESET: 'keyboard.reset',
  KEYBOARD_CLOSE: 'keyboard.close',
  KEYBOARD_HELP: 'keyboard.help',

  ERROR_CONSECUTIVE_FAILURES: 'error.consecutiveFailures',
  ERROR_CHECK_CONNECTION: 'error.checkConnection',
  ERROR_CONTINUE_SILENT: 'error.continueSilent',

  MULTITAB_STATE_CHANGED: 'multitab.stateChanged',
  MULTITAB_RELOAD: 'multitab.reload',

  GUIDELINE_TITLE: 'guideline.title',
  GUIDELINE_ABOUT_TITLE: 'guideline.aboutTitle',
  GUIDELINE_ABOUT_CONTENT: 'guideline.aboutContent',
  GUIDELINE_HOW_TO_WIN_TITLE: 'guideline.howToWinTitle',
  GUIDELINE_HOW_TO_WIN_CONTENT: 'guideline.howToWinContent',
  GUIDELINE_HOW_TO_USE_TITLE: 'guideline.howToUseTitle',
  GUIDELINE_HOW_TO_USE_CONTENT: 'guideline.howToUseContent',
  GUIDELINE_CLOSE: 'guideline.close',
  HEADER_GUIDELINE: 'header.guideline',

  DONATE_BUTTON: 'donate.button',
  DONATE_TITLE: 'donate.title',
  DONATE_THANK_YOU: 'donate.thankYou',
  DONATE_MESSAGE: 'donate.message',
  DONATE_SCAN_QR: 'donate.scanQr',
  DONATE_CLOSE: 'donate.close',

  TERMS_LINK: 'terms.link',
  TERMS_TITLE: 'terms.title',
  TERMS_SECTION_1_TITLE: 'terms.section1Title',
  TERMS_SECTION_1_CONTENT: 'terms.section1Content',
  TERMS_SECTION_2_TITLE: 'terms.section2Title',
  TERMS_SECTION_2_CONTENT: 'terms.section2Content',
  TERMS_SECTION_3_TITLE: 'terms.section3Title',
  TERMS_SECTION_3_CONTENT: 'terms.section3Content',
  TERMS_SECTION_4_TITLE: 'terms.section4Title',
  TERMS_SECTION_4_CONTENT: 'terms.section4Content',
  TERMS_SECTION_5_TITLE: 'terms.section5Title',
  TERMS_SECTION_5_CONTENT: 'terms.section5Content',
  TERMS_CLOSE: 'terms.close',
} as const;
